module.exports = __webpack_public_path__ + "static/media/SHREECEM_F1.58f1ea05.txt";